import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

export const EXTENDED_GUTTER = 150;
export const PANEL_BASE_WIDTH = 650;
export const EXTENDED_PREVIEW_MIN_WIDTH = 520;
export const EXTENDED_PREVIEW_MAX_WIDTH = 940;
export const MIN_EXTENDED_VIEW_WIDTH =
  PANEL_BASE_WIDTH + EXTENDED_PREVIEW_MIN_WIDTH + EXTENDED_GUTTER;

export const FullHeightStack = styled(Stack)`
  height: 100%;
`;

export const PanelContent = styled.div`
  padding: ${Tokens.spacing['3']} ${Tokens.spacing['3']} 0
    ${Tokens.spacing['3']};
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
`;

export const PanelLayout = styled.div`
  display: flex;
  height: 100%;
`;

export const SidePanelIconButton = styled.div`
  padding-top: ${Tokens.spacing['0.5']};
  flex-shrink: 0;
`;

export const Footer = styled.div`
  bottom: 0;
`;

export const ResumePreviewContainer = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: ${EXTENDED_PREVIEW_MAX_WIDTH}px;
  background: ${FullPalette.WHITE};
  border-right: 1px solid ${FullPalette.GREY_700};
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const ResumePreviewBody = styled.div`
  flex: 1;
  min-height: 0;
  padding: ${Tokens.spacing['3']};
  display: flex;
  flex-direction: column;
  gap: ${Tokens.spacing['2']};
`;

export const BorderedFrame = styled.div`
  flex: 1;
  min-height: 0;
  border: 1px solid ${FullPalette.GREY_700};
  border-radius: 4px;
  overflow: hidden;
  background: ${FullPalette.WHITE};
`;

export const RightPanelColumn = styled(FullHeightStack)`
  flex: 0 0 ${PANEL_BASE_WIDTH}px;
  min-width: ${PANEL_BASE_WIDTH}px;
  max-width: ${PANEL_BASE_WIDTH}px;
`;

export const HeaderLink = styled.div`
  &&& > a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
